import { useQuery } from '@apollo/client/react'

import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'

export const GetOAuthScopes = graphql(/* GraphQL */ `
  query getOAuthScopes {
    oauthScopes(input: {}) {
      scopes {
        name
        group
        access
        description
        userFriendlyDescription
      }
    }
  }
`)

export type OAuthScope = ResultOf<
  typeof GetOAuthScopes
>['oauthScopes']['scopes'][number]

type UseOAuthScopesResult = {
  scopes: OAuthScope[]
  isLoading: boolean
  hasError: boolean
}

export const useOAuthScopes = (): UseOAuthScopesResult => {
  const { data, loading, error } = useQuery(GetOAuthScopes)

  return {
    scopes: data?.oauthScopes?.scopes ?? [],
    isLoading: loading,
    hasError: !!error,
  }
}
